import {createContext} from "react";

const CardList = createContext(null);

const Cards = [
    {sex: 'F', name: 'Agnieszka Urbanik', image: 'Agnieszka-Urbanik.png', pdf: 'Agnieszka-Urbanik.pdf'},
    {sex: 'F', name: 'Basia Budziakowska', image: 'Basia-Budziakowska.png', pdf: 'Basia-Budziakowska.pdf'},
    {sex: 'F', name: 'Kaja Oleś', image: 'Kaja-Oles.png', pdf: 'Kaja-Oles.pdf'},
    {sex: 'M', name: 'Kamil Targosz', image: 'Kamil-Targosz.png', pdf: 'Kamil-Targosz.pdf'},
    {sex: 'F', name: 'Karolina Piwowarczyk', image: 'Karolina-Piwowarczyk.png', pdf: 'Karolina-Piwowarczyk.pdf'},
    {sex: 'F', name: 'Magdalena Piwowarczyk', image: 'Magdalena-Piwowarczyk.png', pdf: 'Magdalena-Piwowarczyk.pdf'},
    {sex: 'M', name: 'Mariusz Zaczyk', image: 'Mariusz-Zaczyk.png', pdf: 'Mariusz-Zaczyk.pdf'},
    {sex: 'F', name: 'Martyna Niemczyk', image: 'Martyna-Niemczyk.png', pdf: 'Martyna-Niemczyk.pdf'},
    {sex: 'M', name: 'Rafał Ślusarczyk', image: 'Rafal-Slusarczyk.png', pdf: 'Rafal-Slusarczyk.pdf'},
    {sex: 'M', name: 'Piotr Olszewski', image: 'Piotr-Olszewski.png', pdf: 'Piotr-Olszewski.pdf'},
    {sex: 'F', name: 'Alicja Wójtowicz', image: 'Alicja-Wojtowicz.png', pdf: 'Alicja-Wojtowicz.pdf'},
    {sex: 'M', name: 'Grzegorz Kurczap', image: 'Grzegorz-Kurczap.png', pdf: 'Grzegorz-Kurczap.pdf'},
    {sex: 'F', name: 'Joanna Plichta', image: 'Joanna-Plichta.png', pdf: 'Joanna-Plichta.pdf'},
]
export {CardList, Cards};
